// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1831":"bd904a5c","9367":"b536a0f1"}[chunkId] || chunkId) + "." + {"1831":"0e2928c05d5d602f","7020":"727e7ae238343b2b","7086":"fb0811ab2d763385","9367":"15e176eb19879dfc"}[chunkId] + ".js";
};